import { DeviceUUID } from "device-uuid";

const prefix = process.env.NODE_ENV === "development" ? "dev." : "";
const deviceId = prefix + new DeviceUUID().get();

export function lib_getDeviceId() {
  return deviceId;
}
